import { REACT_APP_API } from 'cfgCommon/config'
import axios from 'axios'

const FILES_ROOT = '/files'

/**
 * Asociacion de archivos a entidades.
 * @typedef {Object} FileAssociation
 * @property {String} file_id Id del archivo asociado
 * @property {String} association_id Id del elemento asociado
 * @property {String} entity_name Nombre de la entidad
 * @property {Number?} order Orden numerico
 */

/**
 * Inserta los File_associations recibidos
 * @param {Array<FileAssociation>} fileList 
 * @returns 
 */
export const bulkInsertFileAssociations = async (fileList, entityName, associationId) => {
    const body = {fileList, entityName, associationId}
    const response = await axios.post(REACT_APP_API + `${FILES_ROOT}/associations`, body)

    return response.data
}
